import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import { Helmet } from 'react-helmet-async'

export default function Pressrelease() {
  return (
    <>
      <Helmet>
        <title>Press Release | Gandhi Mandela Foundation</title>
      </Helmet>

      <Header />

      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span>/</span>
            <span>Press Release</span>
          </div>
          <h1>Press Release</h1>
        </div>
      </section>

        <section className="press-release-section">
          <div className="container">
            <div className="pdf-wrapper">
              {/* PDF 1 */}
              <div className="pdf-box">
                <iframe
                  src="/pdf/pr1.pdf"
                  title="Press Release 1"
                ></iframe>
                <div className="pdf-content">
                  <h4>Gandhi Mandela Award 2020 Conferred to Nobel Peace Prize laureate Rigoberta Menchú Tum</h4>
                </div>
              </div>
              {/* PDF 2 */}
              <div className="pdf-box">
                <iframe
                  src="/pdf/pr2.pdf"
                  title="Press Release 2"
                ></iframe>

                <div className="pdf-content">
                  <h4>Celebration of Nelson Mandela Day on 18th July 2024 by Gandhi Mandela Foundation and United Service Institution</h4>
                </div>
              </div>

            </div>
          </div>
        </section>
        <hr />
        <section className="press-details">
          <div className="container">

            <h2 className="press-title">
              PEACE MARCH ON UKRAINE CRISIS
            </h2>

            <div className="press-detail-wrapper">

              {/* Left Content */}
               <div className="press-image">
                <img
                  src="/img/pr.jpeg"
                  alt="Press Release"
                />
              </div>

              {/* Right Image */}
             <div className="press-text">

                <h4>
                  Peace March on Ukraine Crisis
                </h4>

                <h4>30 January 2020</h4>

                <h4>New Delhi</h4>

                <p>
                  Gandhi Mandela Foundation organized a “Peace March” on 3rd March 2022 at Jantar Mantar, New Delhi to awaken the conscience of humanity and give a call for the immediate cessation of war between Russia & Ukraine.
                </p>

                <p>
                  The march was led by Dr Ved Pratap Vaidik (An Expert on International Affairs, Veteran Journalist & Advisor, GMF), Acharya Dr Lokesh Muni (Vice-Chairman, GMF and Founder-President of Ahimsa Vishwa Bharti) and Spiritual leader Dr Bante Sumedho (Director, International Affairs, GMF). The March was also joined by other interfaith religious leaders, social activists and students and teachers from various institutions.
                </p>
                <p>
                  Acharya Lokesh Muni ji in his speech said that through this gathering we appeal to United Nations and all the countries around the world especially Russia and Ukraine that war and non-violence is not the solution to any problem, it only leads to severe consequences, while the only solution to even the biggest problem is peace through dialogue. “Today I was going through an article by our great thinker Dr Vaidik ji where it was underlined that even after violence and war we have to come to the talking terms then what is the need for the bloodshed. 
                </p>

              </div>
              
            </div>
                <p>
                  Acharya Lokesh Muni ji in his speech said that through this gathering we appeal to United Nations and all the countries around the world especially Russia and Ukraine that war and non-violence is not the solution to any problem, it only leads to severe consequences, while the only solution to even the biggest problem is peace through dialogue. “Today I was going through an article by our great thinker Dr Vaidik ji where it was underlined that even after violence and war we have to come to the talking terms then what is the need for the bloodshed. So, through the media platform, I want to urge the United Nations and Russia & Ukraine to end the war and come to talking terms peacefully because it has led to so much destruction and nothing has been achieved.
                </p>
                <p>
                  are not against any country or religion, we are against war. We need peace and that is the need of the hour,” he added. Dr Ved Pratap Vaidik highlighted the importance of maintaining peace and said that it is the responsibility of our youth to spread the message of peace in the world. “As I have always said that violence does no good and what we are witnessing in Ukraine is very unfortunate. We need to understand how important the principles of Mahatma Gandhi and Nelson Mandela are in today’s world. This is a great initiative by Gandhi Mandela Foundation and Mr Nandan Jha. Today we all should stand up for humanity. As we know, our Prime Minister is doing his every bit to bring back the stranded Indians and the whole world is witnessing how Mr Modi is standing up for the unity of mankind. We need to stand up with him and all our students who are present here should truly follow the footsteps of Gandhi and Mandela”, he added.
                </p>
                <p>
                  Dr Bante Sumedho in his speech said that it is our duty to urge the whole world to walk on the path of peace and non-violence. He said, “As we know that where there is education, there is no place for war and where the war is, there can’t be education. It is the duty of each and every country of the world to be ready for a peace initiative, be it India, Pakistan or China. We need to walk on the path of Gautam Buddh. We need principles of Mahatma Gandhi to enlighten our path”.
                </p>
                <p>
                  Various social activists and other eminent personalities also echoed their sentiments on the Russia-Ukraine war and prayed for world peace and harmony during these difficult times. All the eminent personalities also lit candles and prayed for peace for the departed souls of the two Indian students who lost their lives during the ongoing Russia-Ukraine battle.
                </p>
          </div>
           
        </section>
       <hr />
       <section className="press-details">
          <div className="container">

            <h2 className="press-title">
              GLOBAL PRAYER MEETING
            </h2>

            <div className="press-detail-wrapper">

              {/* Left Content */}
               <div className="press-image">
                <img
                  src="/img/pr2.jpeg"
                  alt="Press Release"
                />
              </div>
              

              {/* Right Image */}
             <div className="press-text">

                <h4>
                  Global Prayer Meeting
                </h4>

                <h4>Date: 30th January 2022</h4>

                <p>
                  Gandhi Mandela Foundation is going to organize a digital Global Prayer meet on 30th January 2022 at 5:00 pm, as a tribute to the Father of the Nation Mahatma Gandhi on his 74th Martyrdom Day. Distinguished personalities from various fields of life will join to commemorate the great legacy of Father of the nation Mahatma Gandhi during this digital meet.
                </p>

                <p>
                  The topic of the meeting for the speakers will be ‘My life is my message’. The Global Prayer Meet will be aired live facebook page of Gandhi Mandela Awards and will be covered by various social media platforms of the organization like Twitter, Youtube and Instagram.
                </p>
                <p>
                 Eminent personalities joining the Global prayer include Acharya Dr Lokesh Muni ji, Vice-Chairman, Gandhi Mandela Foundation; Dr Savita Singh, Vice-Chairman, Gandhi Mandela Foundation; Agus Indra Udayana, Padma Shri and President, Indonesia GMF; Swami Avdheshanand Giri ji, Chairman, GMF; Justice KG Blakrishnan, Jury Chairman, GMF; Justice Dipak Misra, Jury, GMF; Justice Kedarnath Upadhyay, Jury, GMF; Justice Md Tafazzul Islam, Former Chief Justice of Bangladesh, Veteran Journalist Dr Ved Pratap Vaidik; Yog guru Baba Ramdev ji, Founder, Patanjali Yogpeeth and Patron, GMF; Swami Chidanand Saraswati ji, Vice Chairman, GMF; Mr Nandan Jha,, Secretary General, GMF; 
                </p>

              </div>
              
            </div>
                <p>
                  Sadhvi Bhagwati Saraswati Ji, President, Divine Shakti Foundation; HE Roger Gopaul, Hon’ble High Commissioner, High Commission of Republic of Trinidad & Tobago in India; HE Deliwe Ndhlema, Hon’ble Acting High Commissioner, High Commission of Zambia in India; HE Muhammad Imran, Hon’ble High Commissioner, High Commission of Bangladesh in India; Vijay Goel, Hon’ble Vice Chairman, Gandhi Smriti and Darshan Samiti; Dr Mohd Ali Rabbani, Cultural Counselor, Islamic Republic of Iran in India; International Spiritual Preceptor Dr Pawan Sinha ji; Political activist Ajay Bhutoria; Bernard Isaac Wekesa, Political Counselor, High Commision of Kenya in India; Chief Temitope Ajayi, Queen Mother of Nigeria; Dayankar Ratakonda, Director International Affairs, GMF and Dr Bu Abdullah.
                </p>
                <p>
                  Sadhvi Bhagwati Saraswati Ji, President, Divine Shakti Foundation; HE Roger Gopaul, Hon’ble High Commissioner, High Commission of Republic of Trinidad & Tobago in India; HE Deliwe Ndhlema, Hon’ble Acting High Commissioner, High Commission of Zambia in India; HE Muhammad Imran, Hon’ble High Commissioner, High Commission of Bangladesh in India; Vijay Goel, Hon’ble Vice Chairman, Gandhi Smriti and Darshan Samiti; Dr Mohd Ali Rabbani, Cultural Counselor, Islamic Republic of Iran in India; International Spiritual Preceptor Dr Pawan Sinha ji; Political activist Ajay Bhutoria; Bernard Isaac Wekesa, Political Counselor, High Commision of Kenya in India; Chief Temitope Ajayi, Queen Mother of Nigeria; Dayankar Ratakonda, Director International Affairs, GMF and Dr Bu Abdullah.
                </p>
                <p>
                 The Foundation instituted the Gandhi Mandela Awards during the 150th birth anniversary of Gandhiji to celebrate those who have carried forward that the legacies of Mahatma Gandhi and Nelson Mandela.
                </p>
          </div>
           
        </section>
        <hr />

        <section className="press-layout">
            <div className="container">
                <h2 className="press-title">
                  FELICITATION OF HIS HOLINESS THE DALAI LAMA
                </h2>
              <div className="press-layout-wrapper">

                {/* Left Image */}
                <div className="press-img-box">
                  <img
                    src="/img/pr3.jpg"
                    alt="Press Release"
                  />
                </div>

                {/* Right PDF */}
                <div className="press-pdf-box">
                  <iframe
                    src="/pdf/pr3.pdf"
                    title="Press Release PDF"
                  ></iframe>
                </div>

              </div>

            </div>
          </section>
      <Footer />
    </>
  )
}